import React from 'react';
import { Redirect } from 'react-router-dom';

const RedirectToHome = ()=>(<Redirect to={'/'}/>)

export default RedirectToHome;
